export default __webpack_public_path__ + "static/media/standsExpo_signify.62dbf984.jpg";